import React from 'react'
import { Link } from 'react-router-dom'
import { ProductData } from 'lib/types'
import { useGTM } from 'lib/core/hooks'
import { ListPages } from 'lib/core/services/gtm'
import { AddToWishlist, ProductPrice, useProductStatus } from 'lib/modules/catalog'
import {
  Container,
  Image,
  Name,
  Data,
  Price,
  Flags,
  AddToWishlistContainer
} from './styled'

interface Props {
  product: ProductData
  listPage: ListPages
}

export const ProductCard = ({ product, listPage }: Props) => {
  const {
    name,
    image,
    price,
    sku,
    typeName,
    getUrlPath
  } = product

  const { getIsNew, getIsSale } = useProductStatus(product)
  const { triggerProductClick } = useGTM()

  const callGTM = () => {
    triggerProductClick({ sku, name, listPage })
  }

  const isNew = getIsNew()
  const isSale = getIsSale()

  return (
    <Container>
      <AddToWishlistContainer>
        <AddToWishlist
          sku={sku}
        />
      </AddToWishlistContainer>
      <Link onClick={callGTM} to={getUrlPath()} />
      <Image>
        <span
          style={{ backgroundImage: `url(${image.small.url})` }}
        />
      </Image>
      <Data>
        <Name>
          {name}
        </Name>

        <Price>
          <ProductPrice
            price={price}
            type={typeName}
          />
        </Price>
      </Data>
      <Flags>
        {isNew && (
          <span className='flag-new'>New</span>
        )}

        {isSale && (
          <span className='flag-sale'>Sale</span>
        )}
      </Flags>
    </Container>
  )
}
